import localScaleManager from "../../../../helpers/LocalScaleManager";

export class Actions {
  /**
   * @param scene {GameScene}
   * @param table {Table}
   * @param isMyTable {boolean}
   * @param seat {Seat}
   */
  constructor(scene, table, isMyTable, seat) {
    this.scene = scene;
    this.table = table;
    this.seat = seat;
    this.isMyTable = isMyTable;
    this.atlasTexture = this.scene.atlasTexture;
    this.actions = {
      bet: this.scene.add.image(0, 0, this.atlasTexture, "bet"),
      call: this.scene.add.image(0, 0, this.atlasTexture, "call"),
      check: this.scene.add.image(0, 0, this.atlasTexture, "check-action"),
      raise: this.scene.add.image(0, 0, this.atlasTexture, "raise"),
    };
    this.table.poolArray.push(
      ...[
        this.actions.bet,
        this.actions.call,
        this.actions.check,
        this.actions.raise,
      ]
    );

    this.away = this.scene.add
      .image(0, 0, this.atlasTexture, "away")
      .setOrigin(0.5)
      .setDepth(10)
      .setVisible(false);
    this.table.poolArray.push(this.away);

    this.fold = this.scene.add
      .image(0, 0, this.atlasTexture, "fold")
      .setOrigin(0.5)
      .setDepth(10)
      .setVisible(false);
    this.table.poolArray.push(this.fold);

    this.allin = this.scene.add
      .image(0, 0, this.atlasTexture, "all-in")
      .setOrigin(0.5)
      .setDepth(10)
      .setVisible(false);
    this.table.poolArray.push(this.allin);

    for (const actionKey in this.actions) {
      this.actions[actionKey].setOrigin(0.5).setDepth(11).setVisible(false);
    }
    // this.visibilityControls(false);
    this.foldSoundPlayed = false;
  }
  showAction(name) {
    this.visibilityControls(false);
    if (name !== "Fold" && this.foldSoundPlayed) {
      this.foldSoundPlayed = false;
    }
    if (name !== "Fold" && name !== "SitOut") {
      this.hide(this.fold);
      this.hide(this.away);
    } else if (name === "SitOut") {
      this.hide(this.fold);
    } else if (name === "Fold") {
      this.hide(this.away);
    }
    switch (name) {
      case "AllIn": {
        this.show(this.allin, true);
        // this.actions.allin.setVisible(true);
        // this.allin.setVisible(true);
        break;
      }
      case "Bet": {
        this.show(this.actions.bet, true);
        this.table.sounds.play("bet");
        break;
      }
      case "Call": {
        this.show(this.actions.call, true);
        this.table.sounds.play("call");
        break;
      }
      case "Check": {
        this.show(this.actions.check, true);
        this.table.sounds.play("check");
        break;
      }
      case "Fold": {
        if (!this.fold.visible) {
          // this.show(this.fold, this.isMyTable);
          this.show(this.fold, true);
          if (!this.foldSoundPlayed) {
            this.table.sounds.play("fold");
            this.foldSoundPlayed = true;
          }
        }
        break;
      }
      case "Raise": {
        this.show(this.actions.raise, true);
        this.table.sounds.play("raise");
        break;
      }
      case "SitOut": {
        this.show(this.away, false);
        break;
      }
    }

    // setTimeout(() => {
    //     this.visibilityControls(false);
    // }, 2000);
  }
  visibilityControls(visibility) {
    for (const actionKey in this.actions) {
      if (!visibility) {
        if (this.actions[actionKey].visible) this.hide(this.actions[actionKey]);
      } else {
        if (this.actions[actionKey].visible !== visibility)
          this.actions[actionKey].setVisible(visibility);
      }
    }
  }

  /**
   * @param action{Phaser.GameObjects.Image}
   * @param willItBeHidden{Boolean}
   */
  show(action, willItBeHidden) {
    // action.setY(action.getData("initY"));
    if (this.scene.tweenEnable) {
      if (!action.visible) {
        action.setVisible(true);
        action.setAlpha(0);
        // this.seat.box.setAlpha(.1)
        this.scene.tweens.add({
          targets: action,
          // y: `-=${action.displayHeight / 4}`,
          ease: "Linear",
          duration: 200,
          // yoyo: true,
          alpha: {
            // delay: 60,
            value: 1,
            // duration: 40,
            // ease: "Linear",
            // yoyo: false,
          },
          onComplete: () => {
            if (willItBeHidden) this.hide(action, 2000);
          },
        });
        this.scene.tweens.add({
          targets: this.seat.box,
          ease: "Linear",
          duration: 300,
          alpha: 0.1,
        });
      }
    }
  }
  hide(action, delay) {
    // action.setY(action.getData("initY"));
    if (this.scene.tweenEnable && action.visible) {
      this.scene.tweens.add({
        targets: action,
        duration: 300,
        ease: "Linear",
        delay: delay ? delay : 0,
        alpha: {
          // delay: delay ? delay : 0,
          value: 0,
          // duration: 270,
          // ease: "Linear",
          // yoyo: false,
        },
        // y: `-=${action.displayHeight / 4}`,
        // yoyo: true,
        onComplete: () => {
          if (action.visible) {
            action.setVisible(false);
          }
        },
      });
      this.scene.tweens.add({
        targets: this.seat.box,
        duration: 300,
        ease: "Linear",
        delay: delay ? delay : 0,
        alpha: 0.9,
        onComplete: () => {
          this.seat.box.resetAlpha();
        },
      });
    } else {
      if (action.visible) {
        action.setVisible(false);
        this.seat.box.resetAlpha();
      }
    }
    // if(!action.visible)this.seat.box.resetAlpha()
  }
  /***
   *
   * @param width {number} width of seat box
   * @param height {number} width of seat box
   * @param initX {number} seat box top left x
   * @param initY {number} seat box top left y
   */
  positionControls(width, height, initX, initY) {
    // const actionSize = this.isMyTable ? width / 6 : width / 3.5;
    let actionSize = width;
    for (const actionKey in this.actions) {
      localScaleManager.scaleSprite(
        this.actions[actionKey],
        actionSize,
        actionSize,
        0,
        1,
        true
      );
      this.actions[actionKey].setPosition(initX, initY + height * 0.15);
      this.actions[actionKey].setData("initY", this.actions[actionKey].y);
    }
    localScaleManager.scaleSprite(
      this.away,
      actionSize,
      actionSize,
      0,
      1,
      true
    );
    this.away.setPosition(
      initX,
      initY + height * 0.15
      //  initY - this.away.displayHeight
    );
    this.away.setData("initY", this.away.y);

    localScaleManager.scaleSprite(
      this.fold,
      actionSize,
      actionSize,
      0,
      1,
      true
    );
    this.fold.setPosition(
      initX,
      initY + height * 0.15 // initY - this.fold.displayHeight * (this.isMyTable ? 0.5 : 1)
    );
    this.fold.setData("initY", this.fold.y);

    localScaleManager.scaleSprite(
      this.allin,
      actionSize * 1.03,
      actionSize * 1.03,
      0,
      1,
      true
    );
    this.allin.setPosition(
      initX - width * 0.02,
      initY + height * 0.25 // initY - this.allin.displayHeight * (this.isMyTable ? 0.5 : 1)
    );
    this.allin.setData("initY", this.allin.y);
    // const allinSize = width / 1.2;
    // const allinScale = localScaleManager.scaleSprite(this.allin, allinSize, allinSize, 0, 1, true);
    // localScaleManager.scaleSpriteTo(this.allin, allinScale);
    // this.allin.setPosition(initX, initY - this.actions.raise.displayHeight / 1.2 );
  }
  reposition(width, height, initX, initY) {
    for (const actionKey in this.actions) {
      this.actions[actionKey].setPosition(initX, initY + height * 0.15);
      this.actions[actionKey].setData("initY", this.actions[actionKey].y);
    }
    this.away.setPosition(initX, initY + height * 0.15);
    this.away.setData("initY", this.away.y);
    this.fold.setPosition(initX, initY + height * 0.15);
    this.fold.setData("initY", this.fold.y);
    this.allin.setPosition(
      initX - width * 0.02,
      initY + height * 0.25 // initY - this.allin.displayHeight * (this.isMyTable ? 0.5 : 1)
    );
    this.allin.setData("initY", this.allin.y);
  }
  remove() {
    for (const actionKey in this.actions) {
      this.actions[actionKey].destroy();
    }
    this.away.destroy();
  }
}
